export enum AlgorithmStatusType {
  InProgress = 0,
  Failed = -1,
  Success = 1,
  Fallback = -2,
}
